// extracted by mini-css-extract-plugin
export default {"toast":"TimedToast_toast__OD5Uu"};